import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import {Grid } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import {
  FaCheck,
  FaEdit,
  FaEye,
  FaMobileAlt,
  FaPhone,
  FaTrash,
  FaUserCircle,
  FaWindowClose,
} from "react-icons/fa";
import {
  Box,
  Button,
  Menu,
  MenuItem,
  TableBody,
  Divider ,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Fade from "@mui/material/Fade";

import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Pagination from "@mui/material/Pagination";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import FilterListIcon from "@mui/icons-material/FilterList";
import { BsFillArchiveFill } from "react-icons/bs";
// import MailBody from "../MailBody/MailBody";
// import Message from "../Message/Message";
// import TicketSearch from "../TicketSearch/TicketSearch";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import { gridColumnsTotalWidthSelector } from "@mui/x-data-grid";
import { FiClock, FiFileText, FiSearch, FiTarget } from "react-icons/fi";





console.log(sessionStorage.getItem("project_name"));

const PrName = sessionStorage.getItem("ProjectName");
console.log(PrName);

const CrmHead = () => {
  const [tickets, setTickets] = useState([]);

  React.useEffect(() => {
    axios
      .get("https://buildfastvapi.emedha.in/internal/api/v1/api/tickets")
      .then((response) => {
        const crmTickets = response.data.filter(
          (ticket) => ticket.receiver === "CRM Head"
        );
        setTickets(crmTickets);
      })
      .catch((error) => console.error("Error fetching tickets:", error));
  }, []);

  const handleReply = (ticketNumber) => {
    console.log("Reply to ticket:", ticketNumber);
  };

  const handleCancel = (ticketNumber) => {
    console.log("Cancel ticket:", ticketNumber);
  };

  const handleSubmit = (ticketNumber) => {
    console.log("Submit ticket:", ticketNumber);
  };

  const handleTicketClosed = (ticketNumber) => {
    setTickets(
      tickets.filter((ticket) => ticket.ticket_number !== ticketNumber)
    );
  };

 
const [projectName, setProjectName] = useState("");
const [projectNameVilla,setProjectNameVilla]=useState("")


const [fetchedVillaData, setFetchedVillaData] = useState([]); // Initialize with an empty array


// 


const fetchDataVilla = async () => {
  try {
    const response = await fetch(`https://buildfastvapi.emedha.in/create-customer/api/v1/villa-billing-data?projectName=${projectNameVilla}`);
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    const data = await response.json();
    setFetchedVillaData(data); // Update state with fetched data
    console.log(fetchedVillaData)
  } catch (error) {
    console.error('Error fetching data:', error);
    // Handle error (e.g., show error message)
  }
};

useEffect(()=>{
  fetchDataVilla()
},[projectNameVilla])


const [ttowerno, setTowardsTowerNumber] = useState("");

const [responset, setResponset] = useState([]);

const get_floor = () => {
  axios
    .post("https://buildfastvapi.emedha.in/project/api/v1/towers-getall")
    .then((res) => {
      if (res.data.status === 200) {
        setResponset(res.data.data);
        console.log(res.data.data);
      }
    });
};

React.useEffect(() => {

  get_floor();

}, []);



const [response4, setResponse4] = React.useState([]);
const [selectedFloor, setSelectedFloor] = useState('');

const handleFloorChange =async (e) => {
  const floor = e.target.value;
  setSelectedFloor(floor);

}

console.log(response4)

// https://buildfastvapi.emedha.in/project/api/v1/blockwise-floor

const get_floors = (ttowerno) => {
  axios
    .post(
      "https://buildfastvapi.emedha.in/project/api/v1/blockwise-floor",
      {
        value1: ttowerno,
      }
    )
    .then((res) => {
      setResponse4(res.data);
      // setTower(value1);
      //select_floor();
    });
};

// https://buildfastvapi.emedha.in/create-customer/api/v1/bill/tower/data?ttowerno=${ttowerno}

const [fetchedData, setFetchedData] = useState([]); // Initialize with an empty array

const fetchData = async () => {
  try {
    const response = await fetch(`https://buildfastvapi.emedha.in/create-customer/api/v1/bill/tower/data?ttowerno=${ttowerno}&floor=${selectedFloor}`);
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    const data = await response.json();
    setFetchedData(data); // Update state with fetched data
    console.log(fetchedData)
  } catch (error) {
    console.error('Error fetching data:', error);
    // Handle error (e.g., show error message)
  }
};

useEffect(() => {
  get_floors(ttowerno)
  if (ttowerno  && selectedFloor) {
    fetchData();
  }
}, [ttowerno,selectedFloor]); // Dependencies for useEffect

useEffect(() => {
  console.log(fetchedData); // Log fetchedData whenever it changes
}, [fetchedData]); // Run this effect whenever fetchedData changes

const billingCount=fetchedData.length
console.log(billingCount)

const [popupOpen, setPopupOpen] = useState(false);
const [selectedItem, setSelectedItem] = useState(null); // State to store selected item for popup

const handleTotalValueClick = (item) => {
  setSelectedItem(item)
  setPopupOpen(true);
};

const handleClosePopup = () => {
  setSelectedItem(null); // Close popup by resetting selected item
  setPopupOpen(false); // Close the popup
};



const [filterInput, setFilterInput] = useState('');
const [filteredData, setFilteredData] = useState(fetchedData);

React.useEffect(() => {
  setFilteredData(fetchedData);

}, [fetchedData]);


const handleFilterInputChange = (event) => {
  const value = event.target.value.toLowerCase();
  setFilterInput(value);
  const filtered = fetchedData.filter(
    (item) =>
      item.ucin.toLowerCase().includes(value) ||
    
      item.flatNo.toLowerCase().includes(value)
  );
  setFilteredData(filtered);
// Reset page when applying filters
};

console.log(selectedItem);

const countFilledInvoices = (data) => {
  let invoiceCount = 0; // Counter for invoices in main object
  let paymentInvoiceCount = 0; // Counter for invoices in payments array

  // Loop through each object in the fetchedData array
  data.forEach((item) => {
    // Check invoices in the main object
    for (let i = 1; i <= 10; i++) {
      const invoiceKey = `invoice${i}`;
      if (item[invoiceKey] !== "0" && item[invoiceKey] !== null) {
        invoiceCount++;
      }
    }

    // Check invoices in payments array if it exists and is an array
    if (Array.isArray(item.payments)) {
      item.payments.forEach((payment) => {
        if (payment.invoice !== "0" && payment.invoice !== null) {
          paymentInvoiceCount++;
        }
      });
    }
  });

  return { invoiceCount, paymentInvoiceCount };
};
// Usage example
const { invoiceCount, paymentInvoiceCount } = countFilledInvoices(fetchedData);
console.log("Number of invoices with filled values in main object:", invoiceCount);
console.log("Number of invoices with filled values in payments:", paymentInvoiceCount);

const Dues=invoiceCount-paymentInvoiceCount


const countFilledInvoicesVilla = (data) => {
  let invoiceCountVilla = 0; // Counter for invoices in main object
  let paymentInvoiceCountVilla = 0; // Counter for invoices in payments array

  // Loop through each object in the fetchedData array
  data.forEach((item) => {
    // Check invoices in the main object
    for (let i = 1; i <= 10; i++) {
      const invoiceKey = `invoice${i}`;
      if (item[invoiceKey] !== "0" && item[invoiceKey] !== null) {
        invoiceCountVilla++;
      }
    }

    // Check invoices in payments array if it exists and is an array
    if (Array.isArray(item.payments)) {
      item.payments.forEach((payment) => {
        if (payment.invoice !== "0" && payment.invoice !== null) {
          paymentInvoiceCountVilla++;
        }
      });
    }
  });

  return { invoiceCountVilla, paymentInvoiceCountVilla };
};
// Usage example
const { invoiceCountVilla, paymentInvoiceCountVilla } = countFilledInvoicesVilla(fetchedVillaData);
console.log("Number of invoices with filled values in main object:", invoiceCountVilla);
console.log("Number of invoices with filled values in payments:", paymentInvoiceCountVilla);

const DuesVilla=invoiceCountVilla-paymentInvoiceCountVilla
const isVilla = sessionStorage.getItem('project_type') === "Villa";
  
  const currentBillingCount = isVilla ? invoiceCountVilla : invoiceCount;
  const currentDues = isVilla ? DuesVilla : Dues;
  const currentMilestones = isVilla ? paymentInvoiceCountVilla : paymentInvoiceCount;

// --- 2. Premium Reusable Card Component ---
  const StatCard = ({ title, value, icon, iconBg, iconColor }) => (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2.5, md: 3 }, // Slightly tighter padding on mobile phones
        borderRadius: "16px",
        backgroundColor: "#ffffff",
        border: "1px solid #E0E5F2",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.02)",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": { 
          transform: "translateY(-4px)", // Gentle lift effect on hover
          boxShadow: "0px 10px 25px rgba(0, 0, 0, 0.05)" 
        }
      }}
    >
      <Box>
        <Typography 
          sx={{ 
            color: "#A3AED0", 
            fontSize: "12px", 
            fontWeight: "700", 
            textTransform: "uppercase", 
            letterSpacing: "0.5px",
            mb: 1 
          }}
        >
          {title}
        </Typography>
        <Typography 
          sx={{ 
            color: "#1B2559", 
            fontSize: { xs: "24px", md: "28px" }, 
            fontWeight: "800",
            lineHeight: 1
          }}
        >
          {value || 0} {/* Safe fallback to 0 */}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "56px", 
          height: "56px", 
          borderRadius: "50%",
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center",
          backgroundColor: iconBg, 
          color: iconColor
        }}
      >
        {icon}
      </Box>
    </Paper>
  );

  {/* --- HELPER FUNCTION: Payment Status Badges --- */}
const getPaymentStatusBadge = (status) => {
  if (!status || status === '0') return <Typography sx={{ color: "#A3AED0", fontSize: "13px" }}>—</Typography>;
  
  const statusLower = status.toLowerCase();
  let bgColor = "#F4F7FE", textColor = "#4318ff"; // Default Blue

  if (statusLower === "approved" || statusLower === "success") {
    bgColor = "#F0FDF4"; textColor = "#10B981"; // Green
  } else if (statusLower === "pending") {
    bgColor = "#FFFBEB"; textColor = "#F59E0B"; // Orange
  } else if (statusLower === "rejected" || statusLower === "failed") {
    bgColor = "#FEF2F2"; textColor = "#DC2626"; // Red
  }

  return (
    <Box sx={{ backgroundColor: bgColor, color: textColor, fontWeight: "700", fontSize: "11px", padding: "4px 10px", borderRadius: "12px", display: "inline-block", textTransform: "uppercase" }}>
      {status}
    </Box>
  );
};

const currentTableData = isVilla ? fetchedVillaData : filteredData;

  return (
    <>
      {/* <div className="main-cards">

        {sessionStorage.getItem('project_type')!=="Villa" &&
        <>
        <div
          className="card-box d-flex flex-column justify-content-center"
          style={{ backgroundColor: "#8a0404", color: "white" }}
        >

          <div className="card-inner text-center">

            <h3>Billing Count</h3>
            <BsFillArchiveFill className="card-icon" />
            <h6>{invoiceCount}</h6>
         
          </div>

        </div>

        <div
          className="card-box d-flex flex-column justify-content-center"
          style={{
            backgroundColor: "#d2be79",
            color: "white",
            height: "135px",
          }}
        >
          <div className="card-inner ">
            <h3>Payment Dues</h3>
            <BsFillArchiveFill className="card-icon" />
            <h6>{Dues}</h6>
          </div>
        </div>

        <div
          className="card-box d-flex flex-column justify-content-center"
          style={{ backgroundColor: "#d35050", color: "white" }}
        >
          <div className="card-inner text-center">
            <h3>Milestones</h3>
            <BsFillArchiveFill className="card-icon" />
            <h6>{paymentInvoiceCount}</h6>
          </div>
        </div>
        </>
}

{sessionStorage.getItem('project_type')==="Villa" &&
        <>
        <div
          className="card-box d-flex flex-column justify-content-center"
          style={{ backgroundColor: "#8a0404", color: "white" }}
        >

          <div className="card-inner text-center">

            <h3>Billing Count</h3>
            <BsFillArchiveFill className="card-icon" />
            <h6>{invoiceCountVilla}</h6>
         
          </div>

        </div>

        <div
          className="card-box d-flex flex-column justify-content-center"
          style={{
            backgroundColor: "#d2be79",
            color: "white",
            height: "135px",
          }}
        >
          <div className="card-inner ">
            <h3>Payment Dues</h3>
            <BsFillArchiveFill className="card-icon" />
            <h6>{DuesVilla}</h6>
          </div>
        </div>

        <div
          className="card-box d-flex flex-column justify-content-center"
          style={{ backgroundColor: "#d35050", color: "white" }}
        >
          <div className="card-inner text-center">
            <h3>Milestones</h3>
            <BsFillArchiveFill className="card-icon" />
            <h6>{paymentInvoiceCountVilla}</h6>
          </div>
        </div>
        </>
}



      </div> */}

<Box sx={{ width: "100%", mb: 4 }}>
      <Grid container spacing={3}>
        
        {/* Card 1: Billing Count */}
        <Grid item xs={12} sm={4}>
          <StatCard 
            title="Billing Count" 
            value={currentBillingCount} 
            icon={<FiFileText size={24} />} 
            iconBg="#F4F7FE" // Soft Blue/Purple
            iconColor="#4318ff" // Deep Premium Purple
          />
        </Grid>

        {/* Card 2: Payment Dues (Red Theme to indicate urgency) */}
        <Grid item xs={12} sm={4}>
          <StatCard 
            title="Payment Dues" 
            value={currentDues} 
            icon={<FiClock size={24} />} 
            iconBg="#FEF2F2" // Soft Red
            iconColor="#DC2626" // Deep Red
          />
        </Grid>

        {/* Card 3: Milestones (Green Theme to indicate progress) */}
        <Grid item xs={12} sm={4}>
          <StatCard 
            title="Milestones" 
            value={currentMilestones} 
            icon={<FiTarget size={24} />} 
            iconBg="#F0FDF4" // Soft Green
            iconColor="#10B981" // Emerald Green
          />
        </Grid>

      </Grid>
    </Box>

 <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, // Stacks vertically on phones, side-by-side on desktop
    alignItems: { xs: "stretch", md: "flex-end" }, // Aligns the bottoms of the inputs perfectly on desktop
    gap: "16px",
    padding: "20px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    border: "1px solid #E0E5F2",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.02)",
    width: "100%",
    boxSizing: "border-box",
    mb: 4, // Adds breathing room below the filter section
  }}
>
  {/* --- 1. Global Search Filter --- */}
  <Box sx={{ flex: 1, minWidth: { xs: "100%", md: "220px" } }}>
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      Search Details
    </Typography>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "45px", // Standard premium input height
        backgroundColor: "#F4F7FE",
        borderRadius: "8px",
        padding: "0 16px",
        border: "1px solid transparent",
        transition: "all 0.2s ease",
        "&:focus-within": {
          border: "1px solid #4318ff", // Premium purple glow on focus
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 12px rgba(67, 24, 255, 0.05)",
        },
      }}
    >
      <FiSearch style={{ color: "#A3AED0", fontSize: "18px", marginRight: "12px" }} />
      <input
        value={filterInput}
        onChange={handleFilterInputChange}
        placeholder="Search..."
        style={{
          width: "100%",
          border: "none",
          outline: "none",
          backgroundColor: "transparent",
          fontSize: "14px",
          color: "#2B3674",
          fontWeight: "500",
        }}
      />
    </Box>
  </Box>

  {/* --- 2. Project Name Dropdown (Handles both Villa and Non-Villa automatically) --- */}
  <Box sx={{ flex: 1, minWidth: { xs: "100%", md: "200px" } }}>
    <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
      Project Name
    </Typography>
    <select
      required
      onChange={(e) => isVilla ? setProjectNameVilla(e.target.value) : setProjectName(e.target.value)}
      style={{
        width: "100%",
        height: "45px",
        padding: "0 16px",
        fontSize: "14px",
        color: "#2B3674",
        backgroundColor: "#ffffff",
        border: "1px solid #E0E5F2",
        borderRadius: "8px",
        outline: "none",
        cursor: "pointer",
        fontWeight: "600",
        transition: "all 0.2s ease",
      }}
      onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
      onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
    >
      <option value="">Select Project</option>
      <option value={isVilla ? sessionStorage.getItem('project_name') : PrName}>
        {isVilla ? sessionStorage.getItem('project_name') : PrName}
      </option>
    </select>
  </Box>

  {/* --- 3. Tower Dropdown (Hidden for Villas) --- */}
  {!isVilla && (
    <Box sx={{ flex: 1, minWidth: { xs: "100%", md: "200px" } }}>
      <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
        Tower
      </Typography>
      <select
        required
        value={ttowerno}
        onChange={(e) => setTowardsTowerNumber(e.target.value)}
        style={{
          width: "100%",
          height: "45px",
          padding: "0 16px",
          fontSize: "14px",
          color: "#2B3674",
          backgroundColor: "#ffffff",
          border: "1px solid #E0E5F2",
          borderRadius: "8px",
          outline: "none",
          cursor: "pointer",
          fontWeight: "600",
          transition: "all 0.2s ease",
        }}
        onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
        onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
      >
        <option value="">Select Tower</option>
        {responset
          .filter((item) => item.Towers.startsWith(projectName))
          .map((item, index) => (
            <option key={index} value={item.Towers}>
              {item.Towers}
            </option>
          ))}
      </select>
    </Box>
  )}

  {/* --- 4. Floor Dropdown (Hidden for Villas) --- */}
  {!isVilla && (
    <Box sx={{ flex: 1, minWidth: { xs: "100%", md: "200px" } }}>
      <Typography sx={{ color: "#A3AED0", fontSize: "11px", fontWeight: "700", textTransform: "uppercase", mb: 1 }}>
        Floor
      </Typography>
      <select
        required
        onChange={handleFloorChange}
        style={{
          width: "100%",
          height: "45px",
          padding: "0 16px",
          fontSize: "14px",
          color: "#2B3674",
          backgroundColor: "#ffffff",
          border: "1px solid #E0E5F2",
          borderRadius: "8px",
          outline: "none",
          cursor: "pointer",
          fontWeight: "600",
          transition: "all 0.2s ease",
        }}
        onFocus={(e) => (e.target.style.border = "1px solid #4318ff")}
        onBlur={(e) => (e.target.style.border = "1px solid #E0E5F2")}
      >
        <option value="">Select Floor</option>
        {[...new Set(response4.map((data) => data.floor.trim()))].map((floor, index) => (
          <option key={index} value={floor}>
            {floor}
          </option>
        ))}
      </select>
    </Box>
  )}
</Box>


{/* ========================================= */}
<Paper 
  elevation={0} 
  sx={{ width: "100%", borderRadius: "12px", border: "1px solid #E0E5F2", backgroundColor: "#ffffff", boxShadow: "0px 4px 15px rgba(0,0,0,0.02)", overflow: "hidden" }}
>
  <TableContainer sx={{ maxHeight: "600px", overflowX: "auto", '&::-webkit-scrollbar': { height: '6px' }, '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' } }}>
    <Table sx={{ minWidth: 800 }} stickyHeader>
      
      {/* PREMIUM HEADER */}
      <TableHead>
        <TableRow>
          {/* Conditionally render headers based on Project Type */}
          {(isVilla 
            ? ["Project Name", "Villa No", "Customer Name", "UCIN", "Total Value"] 
            : ["Floor", "Flat No", "Customer Name", "UCIN", "Total Value"]
          ).map((headCell, index) => (
            <TableCell 
              key={index} 
              align="start" 
              sx={{ background: "linear-gradient(135deg, #4318ff 0%, #6d28d9 100%)", color: "#ffffff", fontWeight: "700", fontSize: "13px", padding: "16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap", zIndex: 2 }}
            >
              {headCell}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>

      {/* TABLE BODY */}
      <TableBody>
        {currentTableData.map((row, index) => (
          <TableRow hover key={row.id || index}>
            <TableCell align="start" sx={{ fontSize: "13px", fontWeight: "700", color: "#2B3674", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
              {isVilla ? row.ProjectName : row.floor}
            </TableCell>
            <TableCell align="start" sx={{ fontSize: "13px", fontWeight: "500", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
              {row.flatNo}
            </TableCell>
            <TableCell align="start" sx={{ fontSize: "13px", fontWeight: "600", color: "#2B3674", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
              {row.customerName}
            </TableCell>
            <TableCell align="start" sx={{ fontSize: "13px", fontWeight: "500", color: "#707eae", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
              {row.ucin}
            </TableCell>
            <TableCell 
              align="start" 
              onClick={() => handleTotalValueClick(row)}
              sx={{ fontSize: "13px", fontWeight: "800", color: "#4318ff", padding: "14px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap", cursor: "pointer", transition: "all 0.2s", "&:hover": { color: "#6d28d9", textDecoration: "underline" } }}
            >
              {row.totalValue}
            </TableCell>
          </TableRow>
        ))}
        {currentTableData.length === 0 && (
          <TableRow>
            <TableCell colSpan={5} align="center" sx={{ padding: "40px", color: "#A3AED0", fontWeight: "600" }}>No records found.</TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
</Paper>

{/* ========================================= */}
{/* 2. BILLING POPUP DIALOG           */}
{/* ========================================= */}
{selectedItem && (
  <Dialog
    open={popupOpen}
    onClose={handleClosePopup}
    maxWidth="lg" // Allows it to be nice and wide on desktop
    fullWidth
    PaperProps={{ sx: { borderRadius: "16px", padding: "10px" } }}
  >
    <DialogTitle sx={{ color: "#1B2559", fontWeight: "800", fontSize: "22px", pb: 1 }}>
      Installments & Billing Ledger
    </DialogTitle>
    <Divider sx={{ mx: 3, mb: 1 }} />
    
    <DialogContent sx={{ padding: "0 24px" }}>
      {/* Table Container allows horizontal scroll on mobile so it doesn't break layout */}
      <TableContainer sx={{ border: "1px solid #E0E5F2", borderRadius: "12px", overflowX: "auto" }}>
        <Table sx={{ minWidth: 900 }}>
          
          {/* Subtle Light-Blue Header for Invoice Table */}
          <TableHead sx={{ backgroundColor: "#F4F7FE" }}>
            <TableRow>
              {["Invoice", "Amount", "Date", "Paid", "Balance", "Status", "Approval", "Txn ID"].map((head, i) => (
                <TableCell key={i} align="start" sx={{ color: "#A3AED0", fontWeight: "700", fontSize: "11px", textTransform: "uppercase", padding: "12px 16px", borderBottom: "1px solid #E0E5F2", whiteSpace: "nowrap" }}>
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {Object.keys(selectedItem).map(key => {
              if (key.startsWith('invoice') && selectedItem[key] !== '0' && selectedItem[key] !== null) {
                const index = key.replace('invoice', '');
                const invoiceNumber = selectedItem[key];
                const TotalBillAmount = selectedItem['gstTotal' + index] || "—";
                const date = selectedItem['date' + index] || "—";
                
                const balanceKey = 'balance' + index;
                const balanceAmount = selectedItem[balanceKey] ? Math.round(parseFloat(selectedItem[balanceKey])) : 0;

                const payment = selectedItem.payments?.find(p => p.invoice === invoiceNumber);
                const paidAmount = payment ? payment.paidAmount : '0';
                const status = payment ? payment.status : '0';
                const approvalDate = payment ? new Date(payment.approvalDate).toLocaleDateString() : '—';
                const transactionId = payment ? payment.transactionId : '—';

                return (
                  <TableRow key={invoiceNumber} hover>
                    <TableCell align="start" sx={{ fontWeight: "700", color: "#1B2559", fontSize: "13px", padding: "12px 16px", borderBottom: "1px solid #E0E5F2" }}>{invoiceNumber}</TableCell>
                    <TableCell align="start" sx={{ fontWeight: "600", color: "#2B3674", fontSize: "13px", padding: "12px 16px", borderBottom: "1px solid #E0E5F2" }}>{TotalBillAmount}</TableCell>
                    <TableCell align="start" sx={{ color: "#707eae", fontSize: "13px", padding: "12px 16px", borderBottom: "1px solid #E0E5F2" }}>{date}</TableCell>
                    <TableCell align="start" sx={{ fontWeight: "600", color: "#10B981", fontSize: "13px", padding: "12px 16px", borderBottom: "1px solid #E0E5F2" }}>{paidAmount}</TableCell>
                    <TableCell align="start" sx={{ fontWeight: "600", color: "#DC2626", fontSize: "13px", padding: "12px 16px", borderBottom: "1px solid #E0E5F2" }}>{balanceAmount}</TableCell>
                    <TableCell align="start" sx={{ padding: "12px 16px", borderBottom: "1px solid #E0E5F2" }}>{getPaymentStatusBadge(status)}</TableCell>
                    <TableCell align="start" sx={{ color: "#707eae", fontSize: "13px", padding: "12px 16px", borderBottom: "1px solid #E0E5F2" }}>{approvalDate === 'Invalid Date' ? '—' : approvalDate}</TableCell>
                    <TableCell align="start" sx={{ color: "#707eae", fontSize: "13px", padding: "12px 16px", borderBottom: "1px solid #E0E5F2" }}>{transactionId}</TableCell>
                  </TableRow>
                );
              }
              return null;
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </DialogContent>
    
    <DialogActions sx={{ padding: "16px 24px" }}>
      <Button 
        onClick={handleClosePopup} 
        sx={{ backgroundColor: "#F4F7FE", color: "#4318ff", fontWeight: "700", textTransform: "none", borderRadius: "8px", padding: "8px 24px", transition: "all 0.2s", "&:hover": { backgroundColor: "#E9EDF7" } }}
      >
        Close
      </Button>
    </DialogActions>
  </Dialog>
)}

      {/* <div>
        <h1
          style={{ color: "blue", textAlign: "center", marginBottom: "25px" }}
        >
          Internal Communication
        </h1>
        <MailBody />
        <h2 style={{ color: "black" }}>Tickets</h2>
        <ul>
          {tickets.map((ticket) => (
            <Message
              key={ticket.id}
              ticket={ticket}
              onReply={handleReply}
              onCancel={handleCancel}
              onSubmit={handleSubmit}
              onTicketClosed={handleTicketClosed}
            />
          ))}
        </ul>
        <TicketSearch />
      </div> */}
    </>
  );
};

export default CrmHead;

// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Modal from "@mui/material/Modal";
// import { Button, TextField } from "@mui/material";
// import MailBody from "../MailBody/MailBody";
// import Message from "../Message/Message";

// const CrmHead = () => {
//   const [tickets, setTickets] = useState([]);
//   const [showReplyModal, setShowReplyModal] = useState(false);
//   const [replyMessage, setReplyMessage] = useState("");
//   const [replyTicketNumber, setReplyTicketNumber] = useState(null);

//   const fetchTickets = () => {
//     axios
//       .get("http://localhost:3003/api/tickets")
//       .then((response) => {
//         const crmTickets = response.data.filter(
//           (ticket) => ticket.receiver === "CRM Head"
//         );
//         setTickets(crmTickets);
//       })
//       .catch((error) => console.error("Error fetching tickets:", error));
//   };

//   useEffect(() => {
//     fetchTickets();
//   }, []);

//   const handleReply = (ticketNumber) => {
//     setShowReplyModal(true);
//     setReplyTicketNumber(ticketNumber);
//   };

//   const handleReplySubmit = () => {
//     axios
//       .post(`http://localhost:3003/api/tickets/reply/${replyTicketNumber}`, { replyContent: replyMessage })
//       .then((response) => {
//         console.log("Reply submitted:", response.data);
//         setShowReplyModal(false);
//         setReplyMessage("");
//         setReplyTicketNumber(null);
//         fetchTickets(); // Fetch tickets again to update the list with the reply
//       })
//       .catch((error) => console.error("Error submitting reply:", error));
//   };

//   const handleCancel = (ticketNumber) => {
//     console.log("Cancel ticket:", ticketNumber);
//   };

//   const handleSubmit = (ticketNumber) => {
//     console.log("Submit ticket:", ticketNumber);
//   };

//   const handleTicketClosed = (ticketNumber) => {
//     setTickets(tickets.filter(ticket => ticket.ticket_number !== ticketNumber));
//   };

//   return (
//     <>
//       <div>
//         <h1 style={{ color: "blue", textAlign: "center", marginBottom: "25px" }}>
//           Internal Communication
//         </h1>
//         <MailBody />
//         <h2 style={{ color: "black" }}>Tickets</h2>
//         <ul>
//           {tickets.map((ticket) => (
//             <Message
//               key={ticket.id}
//               ticket={ticket}
//               onReply={handleReply}
//               onCancel={handleCancel}
//               onSubmit={handleSubmit}
//               onTicketClosed={handleTicketClosed}
//             />
//           ))}
//         </ul>

//         <Modal open={showReplyModal} onClose={() => setShowReplyModal(false)}>
//           <div
//             style={{
//               padding: 20,
//               backgroundColor: "white",
//               margin: "auto",
//               width: "50%",
//               top: "50%",
//               transform: "translateY(-50%)",
//               position: "absolute",
//             }}
//           >
//             <h2>Reply to Ticket</h2>
//             <TextField
//               fullWidth
//               label="Reply"
//               value={replyMessage}
//               onChange={(e) => setReplyMessage(e.target.value)}
//               multiline
//               rows={4}
//               variant="outlined"
//               style={{ marginBottom: 20 }}
//             />
//             <Button variant="contained" color="primary" onClick={handleReplySubmit}>
//               Submit Reply
//             </Button>
//           </div>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default CrmHead;




// {Object.keys(selectedItem).map(key => {
//   if (key.startsWith('invoice') && selectedItem[key] !== '0' && selectedItem[key] !== null) {
//     const index = key.replace('invoice', '');
//     const invoiceNumber = selectedItem[key];
//     const installment = selectedItem['installment' + index];
//     const date = selectedItem['date' + index];

//     // Check if payment for this invoice exists
//     const paymentExists = selectedItem.payment && selectedItem.payment.invoice === invoiceNumber;

//     // If payment exists, use its details; otherwise, default to zeros
//     const paidAmount = paymentExists ? selectedItem.payment.paidAmount : '0';
//     const status = paymentExists ? selectedItem.payment.status : '0';
//     const approvalDate = paymentExists ? selectedItem.payment.approvalDate : '0';
//     const transactionId = paymentExists ? selectedItem.payment.transactionId : '0';

//     return (
//       <TableRow key={key}>
//         <TableCell align="start">{invoiceNumber}</TableCell>
//         <TableCell align="start">{installment}</TableCell>
//         <TableCell align="start">{date}</TableCell>
//         <TableCell align="start">{paidAmount}</TableCell>
//         <TableCell align="start">{status}</TableCell>
//         <TableCell align="start">{approvalDate}</TableCell>
//         <TableCell align="start">{transactionId}</TableCell>
//       </TableRow>
//     );
//   }
//   return null;
// })}